module.exports = "/static/media/lineto-circular-book.c541f8e1.eot";